import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          <div>
            <h3 className="font-heading font-semibold text-lg mb-4">MEDICAL SUPPLY AND MORE</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Reliable, affordable, and delivered with care.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-medium mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/shop" className="text-gray-600 hover:text-medical-primary transition-colors">Shop</Link></li>
              <li><Link to="/about" className="text-gray-600 hover:text-medical-primary transition-colors">About Us</Link></li>
              <li><Link to="/testimonials" className="text-gray-600 hover:text-medical-primary transition-colors">Testimonials</Link></li>
              <li><Link to="/faq" className="text-gray-600 hover:text-medical-primary transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="text-gray-600 hover:text-medical-primary transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-medium mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy-policy" className="text-gray-600 hover:text-medical-primary transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-conditions" className="text-gray-600 hover:text-medical-primary transition-colors">Terms & Conditions</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-medium mb-4">Contact Info</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <Mail className="w-4 h-4 text-medical-primary mt-0.5" />
                <span className="text-gray-600">info@medicalsupplyandmore.com</span>
              </li>
              <li className="flex items-start space-x-2">
                <Phone className="w-4 h-4 text-medical-primary mt-0.5" />
                <span className="text-gray-600">(407) 415-3024</span>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 text-medical-primary mt-0.5" />
                <span className="text-gray-600">Orlando, FL</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-medium mb-4">Business Hours</h4>
            <ul className="space-y-2 text-sm text-gray-600">
              <li className="flex items-start space-x-2">
                <Clock className="w-4 h-4 text-medical-primary mt-0.5" />
                <div>
                  <p>Monday - Friday: 8am - 8pm</p>
                  <p>Saturday: 9am - 5pm</p>
                  <p>Sunday: Closed</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-8 pt-8 text-center text-sm text-gray-600">
          <p>&copy; {new Date().getFullYear()} Medical Supply and More. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;